(function () {
  function getFilteredVariant(variants, optionNames, urlParams) {
    for (let i = 0; i < optionNames.length; i++) {
      const key = `filter.v.option.${optionNames[i].toLowerCase()}`;
      const filterValue = urlParams.get(key);
      if (filterValue) {
        const match = variants.find(v =>
          v.options[i] && v.options[i].toLowerCase() === filterValue.toLowerCase()
        );
        if (match) return match;
      }
    }
    return null;
  }

  function formatMoney(cents) {
    return '$ ' + (cents / 100).toLocaleString('es-MX', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }

    function updatePrices() {
    const urlParams = new URLSearchParams(window.location.search);
    document.querySelectorAll('.price[data-variants]').forEach(span => {
      if (span.dataset.priceUpdated) return;
      try {
        const variants = JSON.parse(span.getAttribute('data-variants'));
        const optionNames = JSON.parse(span.getAttribute('data-option-names'));
        const variant = getFilteredVariant(variants, optionNames, urlParams);
        if (!variant) return;

        const priceEl = span.querySelector('ins .amount');
        const delEl = span.querySelector('del');

        if (variant.discounted_price && variant.discounted_price > 0) {
          if (priceEl) priceEl.textContent = formatMoney(variant.discounted_price);
          if (delEl) {
            const amountEl = delEl.querySelector('.amount');
            if (amountEl) amountEl.textContent = formatMoney(variant.price);
            delEl.style.display = '';
          }
        } else {
          if (priceEl) priceEl.textContent = formatMoney(variant.price);
          if (delEl) delEl.style.display = 'none';
        }

        span.dataset.priceUpdated = '1';
      } catch (e) {
        console.warn('filter-price-update:', e);
      }
    });
  }

  document.addEventListener('DOMContentLoaded', updatePrices);

  document.addEventListener('DOMContentLoaded', () => {
    const grid = document.getElementById('ProductGridContainer');
    if (grid) {
      const observer = new MutationObserver(() => {
        observer.disconnect();
        updatePrices();
        observer.observe(grid, { childList: true, subtree: false });
      });
      observer.observe(grid, { childList: true, subtree: false });
    }
  });
})();
